<template>
    <div>
        <v-container style="max-width: 1300px !important">
            <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 1rem !important;">
                <v-system-bar class="py-5 px-3 system-bar-title" dark>
                    Perfiles
                </v-system-bar>
            </v-card>
            <v-card class="mx-auto my-5 elevation-1"
                style="margin-bottom: 2rem !important;padding: 2rem .6rem 0 .6rem;">
                <v-row>
                    <v-col cols="12" lg="3" md="4">
                        <v-text-field max-width="200" class="mx-3" v-model="searchRol" label="Rol"
                            append-icon="mdi-magnify" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="3" md="4">
                        <el-button type="primary" @click="dialogForm = true">Nuevo</el-button>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="mx-auto my-5" style=" margin:0 auto;padding: 1.5rem;">
                <div>
                    <v-data-table :headers="filteredHeaders" :items="filteredData" :loading="isLoading" dense
                        loading-text="Cargando... Por favor espere" style="margin: 0 auto;">
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top color="yellow">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2 custom-btn" fab dark @click="openEdit(item)" color="yellow"
                                        v-bind="attrs" v-on="on">
                                        <v-icon class="custom-icon" dark>
                                            mdi mdi-account-edit
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar</span>
                            </v-tooltip>
                        </template>
                        <template v-slot:[`item.estado`]="{ item }">
                            <span :class="item.estado ? 'activo' : 'desactivado'">
                                {{ item.estado ? 'Activo' : 'Desactivado' }}
                            </span>1|
                        </template>
                    </v-data-table>
                </div>
                <el-dialog :title="titleForm" :visible.sync="dialogForm" persistent @closed="destruirComponentesForm"
                    @open="abrirComponenteForm">
                    <Form v-if="mostrarForm" @closedialogForm="closedialogForm"></Form>
                </el-dialog>
            </v-card>
            <v-dialog v-model="dialogLoader" persistent width="300"
                style="padding: 1rem;overflow: hidden !important;background: white !important;">
                <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
            </v-dialog>
        </v-container>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
import Form from "./form.vue";
export default {
    data() {
        const generateData = _ => {
            const data = [];
            for (let i = 1; i <= 15; i++) {
                data.push({
                    key: i,
                    label: `Option ${i}`,
                    disabled: false
                });
            }
            return data;
        };
        return {
            dialogForm: false,
            mostrarForm: true,
            periodoActual: null,
            dialogCargaMasiva: false,
            dialogCargaSimple: false,
            data: generateData(),
            value: [],
            rules: {
                nombre: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                usuario_id: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                correo: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                rol_id: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ],
                area_id: [
                    { required: true, message: 'Este campo es obligatorio.', trigger: 'blur' }
                ]
            },
            titleForm: 'Crear Perfil',
            formLabelWidth: '70px',
            valid: true,
            idUsuario: null,
            titleButton: 'Guardar',
            usuarioForm: {
                usuario_id: null,
                nombre: null,
                correo: null,
                rol_id: null,
                area_id: null
            },
            searchSala: [],
            statusEdit: false,
            modal: false,
            searchNombre: null,
            searchRol: null,
            searchArea: null,
            dialogImport: false,
            dialogLoader: false,
            ver: false,
            searchDocumento: "",
            dataPerfiles: [],
            dataEnvio: {
                fecha: null,
            },
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            search: "",
            sortBy: [{ key: "cupos_disponible", order: "asc" }],
            headers: [
                { text: "Rol", value: "nombre" },
                { text: "Fecha de creación", value: "fecha_creacion", align: "center" },
                { text: "Fecha de edición", value: "fecha_edicion", align: "center" },
                /* { text: "Estado", value: "estado", align: "center" }, */
                { text: "Acciones", value: "actions", align: "right" }
            ],
            dialogEdit: false,
            dialogDelete: false,
            isLoading: false,
            menu: false,
            idItem: null,
            itemMes: null,
            itemPeriodo: null,
            dataArray: [],
            arrayAreas: [],
            arrayRoles: [],
            dataUsuariosHisar: [],
            idSystem:null
        };
    },
    watch: {
        dialogEdit(newVal, oldVal) {
            if (newVal) {
                console.log("El diálogo se abrió.");
            } else {
                this.closeEdit();
                console.log("El diálogo se cerró.");
            }
        },
    },
    methods: {
        closedialogForm() {
            this.dialogForm = false;
        },
        destruirComponentesForm() {
            this.mostrarForm = false; // desmonta el componente
        },
        abrirComponenteForm() {
            this.mostrarForm = true;
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        loadUsuarioHisar() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/usuarioIndex/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataUsuariosHisar = res.data;
                            this.dataUsuariosHisar.forEach((item) => {
                                // Calcula el nombre completo y guárdalo en una nueva propiedad 'nombreCompleto'
                                item.idUsuario = parseInt(item.url.split("/")[4], 10);
                            });
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        darAltaUsuario(item) {
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de dar de alta al usuario?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    this.dialogLoader = true;
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .patch(RUTA_API + "/seguridad_usuario/" + item.id + "/", {
                                    estado: true
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.dialogLoader = false;
                                    this.dataInit();

                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });

                }
            });
        },
        darBajaUsuario(item) {
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de dar de baja al usuario?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    this.dialogLoader = true;
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .patch(RUTA_API + "/seguridad_usuario/" + item.id + "/", {
                                    estado: false
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.dialogLoader = false;
                                    this.dataInit();

                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });

                }
            });
        },
        clearForm() {
            this.usuarioForm = {
                nombre: null,
                correo: null,
                rol_id: null,
                area_id: null,
                usuario_id: null
            }
        },
        loadRoles() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/seguridad_roles/?system="+this.idSystem, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayRoles = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadAreas() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/seguridad_area/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayAreas = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        openEdit(item) {
            this.titleForm = 'Editar Usuario';
            this.statusEdit = true;
            /* this.idUsuario = item.id; */
            this.dialogForm = true;
            this.usuarioForm.usuario_id = parseInt(item.usuario_id, 10);
        },
        closeEdit() {
            this.resetForm('usuarioForm');
            this.statusEdit = false;
            this.dialogEdit = false;
            this.titleForm = 'Crear Usuario',
            this.clearForm();
        },
        save() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/seguridad_usuario/", {
                            area_id: this.usuarioForm.area_id,
                            correo: this.usuarioForm.correo,
                            nombre: this.usuarioForm.nombre,
                            rol_id: this.usuarioForm.rol_id,
                            usuario_id: this.usuarioForm.usuario_id
                        }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "El usuario se registró con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.dialogEdit = false;
                            this.dataInit();
                            this.dialogLoader = false;
                            this.clearForm();
                            this.statusEdit = false;

                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        edit() {
            this.dialogLoader = true;
            this.statusEdit = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .put(RUTA_API + "/seguridad_usuario/" + this.idUsuario + "/", this.usuarioForm, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "El usuario se editó con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.clearForm();
                            this.dialogEdit = false;
                            this.dataInit();
                            this.dialogLoader = false;
                            this.statusEdit = false;

                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/seguridad_roles/listar-rol/?system="+this.idSystem, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            this.dataPerfiles = res.data;

                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    this.dialogLoader = false;
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers;
        },
        filteredData() {
            if (!this.searchRol) {
                return this.dataPerfiles;
            }
            let filtered = this.dataPerfiles;
            if (this.searchRol) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = item.nombre;
                    return nombreCompleto.toLowerCase().includes(this.searchRol.toLowerCase());
                });
            }
            return filtered;
        },
    },
    created() {
        this.loadUsuarioHisar();
        this.loadAreas();
        this.loadRoles();
        this.dataInit();
        this.idSystem=sessionStorage.getItem("idSystem");
    },
    components: {
        Form
    },
};
</script>
<style scoped>
.el-form-item__label {
    line-height: 0px !important;
}

.activo {
    color: rgb(255, 255, 255);
    background: #74d467;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

.desactivado {
    color: rgb(255, 255, 255);
    background: #df4141;
    padding: 0.2rem .7rem;
    border-radius: .4rem;
    font-size: 12px;
}

::v-deep .theme--dark.v-system-bar {
    color: hsl(0, 0%, 100%) !important;
}

.layout-loading {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 202;
    background: #e3e3e3b1;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

.system-bar-title {
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 1.2rem 1.4rem !important;
}

::v-deep tr th {
    text-wrap: nowrap !important;
}

::v-deep .v-card {
    box-shadow: 0px 0px 11px 6px rgb(15 61 99 / 27%) !important;
}

::v-deep tr td {
    text-wrap: nowrap !important;
}

::v-deep .theme--dark.v-system-bar {
    background: #1780cd;
}

.custom-btn {
    width: 25px !important;
    height: 25px !important;
}

.custom-icon {
    font-size: 20px !important;
}

.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

td {
    white-space: nowrap;
}
</style>